import { useState, useEffect } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import Dragula from "react-dragula";

const RedirectItems = () => {
    const navigate = useNavigate();
    const [element, setData] = useState([]);

    let [localStorageElement, setLocalStorageElement] = useState(null)

    useEffect(() => {
        fetch(`/assets/json/apps.json`, {
            method: "GET",
        })
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                setData(element.concat(result.data));
            });
        setLocalStorageElement(localStorageElement = JSON.parse(localStorage.getItem("localAppObj")))
    }, []);

    const storageElement = localStorageElement?.map((item, idx) => {
        
      
        return (
            <li
                key={idx}
                onClick={() => {
                    window.open(item.redirect_url);
                }}
            >
                <div className="app_item_inner">
                    <img src={item.img_src} alt="icon" />
                </div>
                <h1>{item.redirect_name}</h1>
            </li>
        )
    })


    const AppElement = element.map((item, idx) => {
        return (
            <li
                key={idx}
                onClick={() => {
                    item.is_redirect == true ? window.open(item.redirect_url) : navigate(item.navigate_path);
                }}
            >
                <div className="app_item_inner">
                    <img src={item.app_icon} alt="icon" />
                </div>
                <h1>{item.title}</h1>
            </li>
        );
    });
    return (
        <>
            <ul className="app_list">{AppElement}{storageElement}</ul>
        </>
    );
};
export default RedirectItems;
